export enum BranchUserPermission {
    AttendanceManagementEdit = "attendance_management_edit",
    AttendanceManagementView = "attendance_management_view",
    ReservationManagementEdit = "reservation_management_edit",
    ReservationManagementView = "reservation_management_view",
    BranchesManagementEdit ="BranchesManagementEdit",
	EvaluationManagementEdit = "evaluation_management_edit",
}
